import React from "react";
import {
  Document,
  Font,
  Image,
  Page,
  Text,
  View,
  StyleSheet,
} from "@react-pdf/renderer";

import RobotoBold from "fonts/Roboto-Bold.ttf";
import RobotoBlack from "fonts/Roboto-Black.ttf";

Font.register({
  family: "Roboto",
  fonts: [
    { src: RobotoBold, fontWeight: 700 },
    { src: RobotoBlack, fontWeight: 900 },
  ],
});

const StickerGdn = ({ data }) => (
  <Document>
    <Page
      size={{ width: 377.95275591, height: 566.92913386 }}
      style={styles.page}
    >
      <View style={styles.text}>
        <Text style={styles.id}>{data.expano_oms_id}</Text>
        <Text style={styles.title}>Zamówienie</Text>
      </View>
      <View style={styles.image}>
        <Image src={data.code} />
      </View>
      <View style={styles.text}>
        <Text style={styles.gdn_id}>{data.id}</Text>
        <Text style={styles.user_text}>{data.date}</Text>
        <Text style={styles.user_text}>{data.user_name}</Text>
        <Text style={styles.user_text}>{data.station_name}</Text>
      </View>
    </Page>
  </Document>
);

const styles = StyleSheet.create({
  page: {
    backgroundColor: "#fff",
    padding: 5,
  },
  text: {
    textAlign: "center",
  },
  id: {
    fontFamily: "Roboto",
    fontSize: 50,
    fontWeight: 900,
    marginVertical: 10,
  },
  title: {
    fontFamily: "Roboto",
    fontWeight: 600,
    fontSize: 25,
    margin: "5px 0",
    color: "#595d6e",
  },
  image: {
    width: "50%",
    marginLeft: "25%",
  },
  gdn_id: {
    fontFamily: "Roboto",
    fontWeight: 600,
    fontSize: 20,
    marginBottom: 20,
  },
  user_text: {
    fontFamily: "Roboto",
    fontWeight: 600,
    fontSize: 18,
    marginVertical: 4
  },
});

export default StickerGdn;
